import React, { useMemo } from 'react'
import { useSetRecoilState } from 'recoil'
import { Button, Table } from '/src/components/common'
import { 
  createVariationAttributesMap, 
  filterVariationAttributes 
} from '/src/components/commerce/product/productUtil'
import { productVariationsModalState } from '../modal/productVariationsModalState'

import './product_variations_table.scss'

const SelectProductVariationButton = ({ id, variationsMap, setProductVariation }) => {
  const setModalDisplay = useSetRecoilState(productVariationsModalState)

  const onClickHandler = () => {
    setProductVariation(variationsMap.find(value => value.id === id))
    setModalDisplay(false)
  }

  return <Button variant="primary" onClick={onClickHandler}>
    Select
  </Button>
}

const buildTableColumns = ({ relationships }) => {
  const results = Object.entries(relationships).map(([key, value]) => {
    if (key.startsWith('attribute_') && value !== null) {
      const name = key.slice(10)

      return {
        Header: name,
        accessor: name
      }
    }
  }).filter(value => value)

  // Add static header.
  results.push({
    Header: 'Select',
    accessor: 'select'
  })

  return results
}

const buildTableData = (variations, setProductVariation) => {
  const attributes = filterVariationAttributes(variations)
  const variationsMap = createVariationAttributesMap(variations, attributes)

  return variations.map(({ id, relationships }) => {
    const values = {
      select: <SelectProductVariationButton 
        id={id} 
        variationsMap={variationsMap} 
        setProductVariation={setProductVariation} />
    }

    for (let [key, value] of Object.entries(relationships)) {
      if (key.startsWith('attribute_') && value) {
        const name = key.slice(10)
        values[name] = value.name
      }
    }

    return values
  })
}

export default ({ variations, setProductVariation }) => {
  const [variation] = variations
  const columns = useMemo(() => buildTableColumns(variation), [variation])
  const data = useMemo(() => buildTableData(variations, setProductVariation), [variations])

  return (
    <>
      <Table className="product-variation-table" columns={columns} data={data} />
    </>
  )
}
